export default function ListBuilderIcon() {
  return <i className="fa-solid fa-list-check"></i>
}